import { Header } from '../components/layout/Header';
import { Footer } from '../components/layout/Footer';
import { HeroBanner } from '../components/home/HeroBanner';
import { LeftSidebar } from '../components/home/LeftSidebar';
import { NewsFeed } from '../components/home/NewsFeed';
import { RightSidebar } from '../components/home/RightSidebar';
import { usePageSEO } from '../hooks/usePageSEO';

export default function HomePage() {
    usePageSEO({
        title: 'Klasowisko.pl - Odnajdź swoją klasę! Portal społecznościowy dla absolwentów',
        description: 'Klasowisko.pl - portal społecznościowy dla absolwentów i uczniów szkół w Polsce. Ponad 37 000 szkół w bazie. Znajdź kolegów ze szkoły, dziel się wspomnieniami!',
        url: 'https://www.klasowisko.pl',
        jsonLd: {
            "@context": "https://schema.org",
            "@type": "WebSite",
            "name": "Klasowisko.pl",
            "url": "https://www.klasowisko.pl",
            "description": "Portal społecznościowy dla absolwentów i uczniów szkół w Polsce",
            "potentialAction": {
                "@type": "SearchAction",
                "target": "https://www.klasowisko.pl/search?q={search_term_string}",
                "query-input": "required name=search_term_string"
            }
        }
    });
    return (
        <div className="min-h-screen flex flex-col bg-background">
            {/* Header */}
            <Header />

            {/* Hero Banner with Search */}
            <HeroBanner />

            {/* Main Content - Classic 3-column layout */}
            <div className="flex-1 max-w-[1400px] mx-auto w-full px-4 py-6">
                <div className="grid grid-cols-1 lg:grid-cols-12 gap-6">
                    {/* Left Sidebar - 20% on desktop */}
                    <div className="hidden lg:block lg:col-span-3 xl:col-span-2">
                        <div className="sticky top-20">
                            <LeftSidebar />
                        </div>
                    </div>

                    {/* Main Feed - 60% on desktop */}
                    <div className="lg:col-span-6 xl:col-span-7">
                        <NewsFeed />
                    </div>

                    {/* Right Sidebar - 20% on desktop */}
                    <div className="lg:col-span-3">
                        <div className="sticky top-20">
                            <RightSidebar />
                        </div>
                    </div>
                </div>
            </div>

            {/* Footer */}
            <Footer />
        </div>
    );
}
